module.exports = __webpack_public_path__ + "img/logo_mirroreality.5ad51a34.png";